import React from "react";
import {
  FaFacebookF,
  FaWhatsapp,
  FaLinkedinIn,
  FaTelegramPlane,
} from "react-icons/fa";

const ShareButtons = ({ url }) => {
  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(url)}`,
  };

  const icons = {
    facebook: <FaFacebookF />,
    whatsapp: <FaWhatsapp />,
    linkedin: <FaLinkedinIn />,
    telegram: <FaTelegramPlane />,
  };

  const colors = {
    facebook: "#1877f2",
    whatsapp: "#25d366",
    linkedin: "#0077b5",
    telegram: "#0088cc",
  };

  const handleShare = (platform) => {
    if (navigator.share) {
      navigator.share({ url }).catch(console.error);
    } else {
      window.open(shareLinks[platform], "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="share-container">
      <h2 className="share-title">Share This Service</h2>
      <div className="share-buttons d-flex gap-3">
        {Object.keys(shareLinks).map((platform) => (
          <button
            key={platform}
            onClick={() => handleShare(platform)}
            aria-label={`Share on ${platform}`}
            style={{
              backgroundColor: colors[platform],
              border: "none",
              borderRadius: "50%",
              width: "45px",
              height: "45px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: "20px",
              cursor: "pointer",
            }}
          >
            {icons[platform]}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ShareButtons;
